export const getZodiac = {
    props: {
        i18n: Object,
    },
    data() {
        return {
            zodiacSigns: {
                capricorn: this.$t("profileEdit.capricorn"),
                aquarius: this.$t("profileEdit.aquarius"),
                pisces: this.$t("profileEdit.pisces"),
                aries: this.$t("profileEdit.aries"),
                taurus: this.$t("profileEdit.taurus"),
                gemini: this.$t("profileEdit.gemini"),
                cancer: this.$t("profileEdit.cancer"),
                leo: this.$t("profileEdit.leo"),
                virgo: this.$t("profileEdit.virgo"),
                libra: this.$t("profileEdit.libra"),
                scorpio: this.$t("profileEdit.scorpio"),
                sagittarius: this.$t("profileEdit.sagittarius"),
            },
        };
    },
    methods: {
        getZodiac(day, month) {
            if ((month == 1 && day <= 20) || (month == 12 && day >= 22)) {
                return this.zodiacSigns.capricorn;
            } else if ((month == 1 && day >= 21) || (month == 2 && day <= 18)) {
                return this.zodiacSigns.aquarius;
            } else if ((month == 2 && day >= 19) || (month == 3 && day <= 20)) {
                return this.zodiacSigns.pisces;
            } else if ((month == 3 && day >= 21) || (month == 4 && day <= 20)) {
                return this.zodiacSigns.aries;
            } else if ((month == 4 && day >= 21) || (month == 5 && day <= 20)) {
                return this.zodiacSigns.taurus;
            } else if ((month == 5 && day >= 21) || (month == 6 && day <= 20)) {
                return this.zodiacSigns.gemini;
            } else if ((month == 6 && day >= 22) || (month == 7 && day <= 22)) {
                return this.zodiacSigns.cancer;
            } else if ((month == 7 && day >= 23) || (month == 8 && day <= 23)) {
                return this.zodiacSigns.leo;
            } else if ((month == 8 && day >= 24) || (month == 9 && day <= 23)) {
                return this.zodiacSigns.virgo;
            } else if (
                (month == 9 && day >= 24) ||
                (month == 10 && day <= 23)
            ) {
                return this.zodiacSigns.libra;
            } else if (
                (month == 10 && day >= 24) ||
                (month == 11 && day <= 22)
            ) {
                return this.zodiacSigns.scorpio;
            } else if (
                (month == 11 && day >= 23) ||
                (month == 12 && day <= 21)
            ) {
                return this.zodiacSigns.sagittarius;
            }
        },
    },
};
